exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-banners-box[data-v-2e171282]{cursor:pointer}#hpStripBannerCarousel[data-v-2e171282],#hpStripBannerCarousel .item[data-v-2e171282],#hpStripBannerCarousel .item img[data-v-2e171282]{width:100%}", ""]);

// exports
